/**
 *  actionTypes.js
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

export const SAVE_ACCOUNT = 'SAVE_ACCOUNT';
export const CLEAR_ACCOUNT = 'CLEAR_ACCOUNT';

export const SAVE_USERS = 'SAVE_USERS';
export const CLEAR_USERS = 'CLEAR_USERS';

export const SAVE_COURIERS = 'SAVE_COURIERS';
export const CLEAR_COURIERS = 'CLEAR_COURIERS';

export const SHOW_NOTIFICATIONS = 'SHOW_NOTIFICATIONS';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';


// WEBPACK FOOTER //
// ./src/actions/actionTypes.js